import React from 'react';
import clsx from 'clsx';

import { ReactComponent as AlertIcon } from 'assets/alert.svg';

import { useShipment } from '../../hooks/shipment.hooks';
import { TAB_JOURNEY_INPUT_TEST_ID, TAB_OVERVIEW_INPUT_TEST_ID, TAB_SWITCHER_TEST_ID } from './TabSwitcher.test-ids';

import styles from './TabSwitcher.module.scss';

export enum TabSwitcherOptions {
  OVERVIEW = `overview`,
  JOURNEY = `journey`,
}

export interface TabSwitcherProps {
  activeTab: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const TabSwitcher: React.FC<TabSwitcherProps> = ({ activeTab, onChange }) => {
  const notices = useShipment()?.dynamicCommsList ?? [];
  const disruptionNotices = notices.filter((notice) => notice.type === 'DISRUPTION').slice(0, 3);

  const displayDisruptionAlert = () =>
    disruptionNotices &&
    disruptionNotices.length > 0 && (
      <AlertIcon id='JourneyAlert' title='contains an alert about a possible disruption' />
    );

  return (
    <div
      className={styles.tabSwitcherWrapper}
      data-testid={TAB_SWITCHER_TEST_ID}
      role='tablist'
      aria-labelledby='trackingPanelHeading'
    >
      <div className={clsx(styles.slider, activeTab === TabSwitcherOptions.JOURNEY && styles.slideRight)} />
      <div className={styles.tabOption}>
        <div className={styles.tabLabel}>
          <label htmlFor='OptionOverview'>Overview</label>
        </div>
        <input
          type='radio'
          id='OptionOverview'
          value={TabSwitcherOptions.OVERVIEW}
          name='tabSwitcher'
          onChange={onChange}
          checked={activeTab === TabSwitcherOptions.OVERVIEW}
          data-testid={TAB_OVERVIEW_INPUT_TEST_ID}
          role='tab'
          aria-controls='OverviewTabPanel'
          aria-selected={activeTab === TabSwitcherOptions.OVERVIEW}
        />
      </div>
      <div className={styles.tabOption}>
        <div className={styles.tabLabel}>
          <label htmlFor='OptionJourney'>Journey</label>
          {displayDisruptionAlert()}
        </div>
        <input
          type='radio'
          id='OptionJourney'
          value={TabSwitcherOptions.JOURNEY}
          name='tabSwitcher'
          onChange={onChange}
          checked={activeTab === TabSwitcherOptions.JOURNEY}
          data-testid={TAB_JOURNEY_INPUT_TEST_ID}
          role='tab'
          aria-controls='JourneyTabPanel'
          aria-selected={activeTab === TabSwitcherOptions.JOURNEY}
          aria-describedby='JourneyAlert'
        />
      </div>
    </div>
  );
};

export default TabSwitcher;
